"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ArrowIcon;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function ArrowIcon() {
  for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }

  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, rest, /*#__PURE__*/_react.default.createElement("polyline", {
    style: {
      fill: 'none',
      stroke: '#231F20',
      strokeWidth: 0.75,
      strokeLinecap: 'round',
      strokeLinejoin: 'round'
    },
    points: "9,1.5 17.2,12 9,22.5 "
  }));
}